module.exports = vendors_ru_b808f4263177feb71caa;